/*jshint esversion: 11 */
//import { SummaryMenu } from './modules/summaryMenu.js';

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


//calcul de la hauteur de la page
const scrollHeight = document.documentElement.scrollHeight;
document.body.style = "--scrollHeight: " + scrollHeight +'px';

//bouton retour arrière
if (document.querySelector('.to-goback')) {
  document.querySelector('.to-goback').addEventListener('click', (e) => {
    if (document.referrer !== "" && document.referrer.split('/')[2] === location.hostname) {
      e.preventDefault();
      history.back();
      return false;
    }
  });
}

//comportement du bouton "Haut de page"
if (document.getElementById('backTop')) {
  const focusableElements = document.querySelector('.top-header__logo a');

  document.getElementById('backTop').getElementsByTagName('a')[0].addEventListener('click', function (event) {
    event.preventDefault();

    focusableElements.focus(); //focus sur le logo
  });
}

/**
 * Add smooth animation to Bootstrap dropdowns
 */
if (document.querySelector('.dropdown-menu')) {
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((toggle) => {
    toggle.addEventListener('shown.bs.dropdown', function (e) {
      const menu = toggle.parentElement.querySelector('.dropdown-menu');
      if (menu) {
        menu.classList.remove('animate');
        setTimeout(() => {
          menu.classList.add('animate');
        }, 10);
      }
    });

    toggle.addEventListener('hide.bs.dropdown', function (e) {
      const menu = toggle.parentElement.querySelector('.dropdown-menu');
      if (menu) {
        menu.classList.remove('animate');
      }
    });
  });
}



/********** Menu Sommaire *****************/
if (document.querySelector('.template-summary--links')) {
  import('./modules/summaryMenu.js').then((Module) => {
    new Module.SummaryMenu({
      wrapperClass: '.template-summary--links',
      breakpoints: {
        md: '768'
      }
    });
  });
}
/******************************************** */

//chargement dynamique du script de slidertabs si il y en a un dans le contenu
if (document.querySelector('.tabs.tabs--with-controls .nav-tabs')) {
  import('./modules/slidertabs.js').then((Module) => {
    new Module.SliderTabs({
      selectorTabsContainer: '.tabs .nav-tabs',
      selectorTab: '.tabs .nav-tabs .nav-link',
      selectorPrevArrow: '.tabs .tabs__btn--prev',
      selectorNextArrow: '.tabs .tabs__btn--next'
    });
  });

  // Ajout de l'attribut aria-hidden true/false Mantis 0038100
  // On sélectionne les boutons "Précédent" et "Suivant" dans la navigation par onglets
  let btnprevtab = document.querySelector('.tabs .tabs__btn--prev');
  let btnnexttab = document.querySelector('.tabs .tabs__btn--next');

  // Fonction qui vérifie l'affichage actuel d'un bouton et met à jour l'attribut aria-hidden en conséquence
  function checkDisplay(button) {
    // Récupère le style "calculé" par le navigateur (peut inclure les styles CSS externes)
    const computed = window.getComputedStyle(button);

    // Vérifie si l'élément est actuellement caché
    const isHidden = computed.display === 'none';

    // Met à jour l'attribut aria-hidden (accessibilité)
    // true si caché, false sinon
    button.setAttribute("aria-hidden", isHidden.toString());
  }

  // Création d’un observateur pour détecter les changements dans les attributs
  const observer = new MutationObserver(() => {
    // À chaque mutation détectée, on vérifie l'état d'affichage des deux boutons
    checkDisplay(btnnexttab);
    checkDisplay(btnprevtab);
  });

  // On demande à l’observateur de surveiller les changements dans les attributs "style" uniquement sur les boutons concernés
  observer.observe(btnnexttab, { attributes: true, attributeFilter: ['style'] }); // On surveille les attribut + On se limite à l’attribut "style" (inline CSS)
  observer.observe(btnprevtab, { attributes: true, attributeFilter: ['style'] }); // On surveille les attribut + On se limite à l’attribut "style" (inline CSS)

  // Appel initial pour les états actuels
  checkDisplay(btnnexttab);
  checkDisplay(btnprevtab);
}

//Suppression de l'attribut style qui pose problème sur le message d'activation
var videos = document.getElementsByClassName('youtube_player');
if(videos.length) {
  // Observation uniquement de la dernière vidéo afin de modifier toutes les vidéos en même temps
  var lastVideo = videos[videos.length - 1];

  var lastVideoConfig = { attributes: true, childList: true };

  var lastVideoCallback = function(mutationsList) {
    if(document.querySelector('.youtube_player .tac_activate')) {
      document.querySelectorAll('.youtube_player').forEach((item) => {
        item.removeAttribute('style');
      });
    }
  };

  // Create the observer
  var lastVideoObserver = new MutationObserver(lastVideoCallback);

  // Observe body to check if DOM inside has changed
  lastVideoObserver.observe(lastVideo, lastVideoConfig);
}


//uniquement pour mobile
//if (/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
  //ajout du focus dans le bloc 'recherche' mobile quand il est ouvert
  var collapseSearchBlockMobile = document.getElementById('search-block--mobile');
  if (collapseSearchBlockMobile) {
    collapseSearchBlockMobile.addEventListener('shown.bs.collapse', function (event) {
      event.target.getElementsByTagName('button')[0].focus();

      document.getElementsByTagName('body')[0].classList.add('stop-scrolling');
    });

    collapseSearchBlockMobile.addEventListener('hide.bs.collapse', function (event) {
      document.getElementsByTagName('body')[0].classList.remove('stop-scrolling');
    });
  }

  /** Ajout/Suppression d'une classe pour fixer le header quand le menu est ouvert/fermé */
  var collapseMainMenu = document.getElementById('main-navbar');
  if (collapseMainMenu) {
    collapseMainMenu.addEventListener('shown.bs.collapse', function (event) {
      document.getElementById('header').classList.add('header--fixed');

      document.getElementsByTagName('body')[0].classList.add('stop-scrolling');
    });

    collapseMainMenu.addEventListener('hide.bs.collapse', function (event) {
      document.getElementById('header').classList.remove('header--fixed');
      document.getElementsByTagName('body')[0].classList.remove('stop-scrolling');
      //document.documentElement.scrollTop='0px'; //repositionnement de l'utilisateur en haut de la page
    });
  }
  /** ---------------------- */

  /** Toggle aria-label du bouton de menu mobile */
  const navbarToggler = document.querySelector('.navbar-toggler');
  const collapseTarget = document.querySelector(navbarToggler.getAttribute('data-bs-target'));

  if (collapseTarget) {
    collapseTarget.addEventListener('shown.bs.collapse', function () {
      navbarToggler.setAttribute('aria-label', 'Fermer le menu de navigation');
    });

    collapseTarget.addEventListener('hidden.bs.collapse', function () {
      navbarToggler.setAttribute('aria-label', 'Ouvrir le menu de navigation');
    });
  }
  /** ---------------------- */
//}
